import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ElementRef } from '@angular/core';
import { UntypedFormBuilder, FormGroup, UntypedFormControl, Validators, ValidatorFn } from '@angular/forms';
import { ProtocolSettingsComponent } from "../ProtocolSettingsComponent";
import { VimSettings } from 'DiscoveryEngine.TS/Protocols';
import { StringUtils } from 'DiscoveryEngine.TS/Utils';

@Component({
    selector: 'vim-settings',
	templateUrl: './vim-settings.component.html',
	styleUrls: ['./vim-settings.component.scss']
})
export class VimSettingsComponent extends ProtocolSettingsComponent<VimSettings> implements OnChanges {

	public Name: UntypedFormControl;
	public Username: UntypedFormControl;
	public Password: UntypedFormControl;
	public PasswordConfirm: UntypedFormControl;
	public ShowChars: UntypedFormControl;
	public IpScope: UntypedFormControl;
	public IsDefault: UntypedFormControl;

	private PasswordChanged: boolean;

	constructor(private fb: UntypedFormBuilder) {
		super();
		this.BuildForm();
	}

	protected BuildForm(): void {
		this.PasswordInputType = "password";

		if (this.Settings) {
			this.Name = new UntypedFormControl(this.Settings.Name, Validators.required);
			this.Username = new UntypedFormControl(this.Settings.UserName, Validators.required);
			this.Password = new UntypedFormControl(this.hidePassword(this.Settings.Password));
			this.PasswordConfirm = new UntypedFormControl(this.hidePassword(this.Settings.Password));
			this.ShowChars = new UntypedFormControl(false);
			this.IpScope = new UntypedFormControl(this.Settings.IpScope.ToString());
			this.IsDefault = new UntypedFormControl(this.Settings.IsDefault);

			this.enableDisableControls();

			this.PasswordChanged = false;

			this.SettingsForm = this.fb.group({
					Name: this.Name,
					Username: this.Username,
					Password: this.Password,
					PasswordConfirm: this.PasswordConfirm,
					ShowChars: this.ShowChars,
					IpScope: this.IpScope,
					IsDefault: this.IsDefault,
				},
				{
					validator: this.equalTo(this.Password, this.PasswordConfirm, "passwordsEqual")
				});
		}
		else {
			this.SettingsForm = null;
			this.Name = null;
			this.Username = null;
			this.Password = null;
			this.PasswordConfirm = null;
			this.ShowChars = null;
			this.IpScope = null;
			this.IsDefault = null;
		}
	}

	public enableDisableControls(): void {
		this.enableDisableFormControl(this.ShowChars, this.AllowShowChars);
	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.BuildForm();
	}

	public get invalidTempChanges(): string[] {
		return ["VMware"];
	}

	public applyTempChanges(): void {
		this.Settings.Name = this.Name.value;
		this.Settings.UserName = this.Username.value;
		if (this.PasswordChanged) {
			this.Settings.Password = StringUtils.ObfuscateString2(this.Password.value);
		}
		this.Settings.IpScope.FromString(this.IpScope.value);
		this.Settings.IsDefault = this.IsDefault.value;

		this.BuildForm();
		this.OnApplyTempChanges();
	}

}
